import React from 'react'
import {Breadcrumb} from 'antd'

export const PageHeader = ({ title, display, routes }) => {
	return (
		display ? (
			<div className="app-page-header" id="app-page-header">
				{/*<h3 className="mb-0 mr-3 font-weight-semibold">
					<IntlMessage id={title? title : 'home'
				}/>
				</h3>*/}
				<Breadcrumb style={{marginTop: ".2rem"}}>
					{routes?.map((route, idx) => 
						route.clickable ? (
							<Breadcrumb.Item key={idx}>
								<font style={{fontWeight: idx === routes.length - 1 ? "bold" : "normal"}} size={4}><a href={route.path}>{route.breadcrumbName}</a></font>
							</Breadcrumb.Item>)
						:
							(<Breadcrumb.Item key={idx}>
								<font style={{fontWeight: idx === routes.length - 1 ? "bold" : "normal"}} size={4}>{route.breadcrumbName}</font>
							</Breadcrumb.Item>)
						)
					}
					
				</Breadcrumb>
				{/*<AppBreadcrumb />*/}
			</div>
		)
		: null
	)
}

export default PageHeader